export default __webpack_public_path__ + "static/media/peripheral1.6cc04d9f.jpg";